import React, {useState} from 'react';
import './HomePage.css';
import Nav from './Nav';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
    const clickMenu = () => {
        setShowPopup(!showPopup);
    }
    const startNow = () => {
        navigate('/login');
    }
  return (
    // <body>

        <div className="landing-container" dir="rtl">
            {/* Header / Navigation */}
            {/* <header className="landing-header">
            <h1 className="landing-logo">ترسيخ</h1>
            <button className="landing-menu-button" onClick={() => setShowPopup(prev => !prev)}>☰</button>
            </header> */}
            <Nav/>


            {/* Main Content */}
            <main className="landing-main">
            {/* Intro Text */}
            <p className="landing-intro">
                صنعت هذه الأداة حتى يكون حفظك لكتاب الله راسخ وثابت في وقت أقل.
            </p>

            {/* Start Button */}
            <button className="landing-start-button" onClick={startNow} >ابدأ الآن</button>

            {/* Section with green chips */}
            <div className="landing-chip">كيفية الحفظ؟</div>
            <p className="landing-paragraph">
            بطريقة التكرار المتباعد، وهي طريقة علمية تساعد في: 
            </p>
            <p className="sub-paragraph">
            جدولة الحفظ مع المراجعة بطريقة علمية حتى يترسخ المحفوظ وينتقل من ذاكرة قصيرة المدى الى ذاكرة طويلة المدى.
            </p>

            <div className="landing-chip">نصائح</div>
            <p className="landing-paragraph">
            حاول ان تقراء ما حفظته او المراجعة التي عليك في صلاواتك.
            عند المراجعة ابتعد عن النظر في النص مباشرة وحاول ان تراجع من محفوظك مباشرة حتى يترسخ الحفظ ويقوى حفظك.
            </p>

            <div className="landing-chip">بفضل الله بالبدء به</div>
            <p className="landing-paragraph">
                حث النبي على سور عظيمة يستحب البدء بها، 
                لما فيها من فضائل عظيمة في الدنيا وفي الممات وبعد الممات.
            </p>

            <h3 className="landing-chip">الفاتحة</h3>
            <p className="landing-paragraph">
                أعظم سورة في القرآن. 
            </p>
            <p className='sub-paragraph'>
            لأعلمنك سورة هي أعظم سورة في القرآن" ثم قال: "الحمد لله رب العالمين..." هي السبع المثاني والقرآن العظيم الذي أوتيته.
            </p>
            <p className='hadith-source'>
                {`-رواه البخاري (عدد:4474)`}
            </p>


            <h3 className="landing-chip">البقرة</h3>
            <p className="landing-paragraph">
            بركة وحفظ من السحر والعين      </p>

                <p className='sub-paragraph'>
                قال رسول الله صلى الله عليه وسلم:
                "اقرؤوا سورةَ البقرة؛ فإن أخذَها بركةٌ، وتركَها حسرةٌ، ولا تستطيعها البطلةُ".                </p>
            <p className='hadith-source'>
                {`-رواه مسلم (عدد:804)`}
                </p>
                <h3 className="landing-chip">الملك</h3>
                <p className="landing-paragraph">
                    تشفع وتنجي من عذاب القبر
                </p>
                <p className='sub-paragraph'>
                قال رسول الله صلى الله عليه وسلم:
                "سورةٌ من القرآن ثلاثون آية شفَعَت لرجلٍ حتى غُفِر له، وهي تبارك الذي بيده الملك".
                </p>
                <p className='hadith-source'>
                {`-رواه الترمذي (عدد:2891)`}
                </p>
                {/* <h3 className="landing-chip">الواقعة</h3>
                <p className="landing-paragraph">
                    مانعة من الفقر        
                </p>
                <p className='sub-paragraph'>
                يُروَى عن النبي صلى الله عليه وسلم أنه قال: 
                "من قرأ سورة الواقعة كل ليلة لم تصبه فاقة" 
                </p>
                <p className='hadith-source'>

                {`-رواه ابن ماجه (عدد:3786)`}
                </p> */}
            </main>
        </div>
    // </body>
  );
};

export default HomePage;
